'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDebouncedEffect = useDebouncedEffect;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function useDebouncedEffect(callback, delay) {
  var deps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var firstUpdate = (0, _react.useRef)(true);
  (0, _react.useEffect)(function () {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    var handler = setTimeout(function () {
      callback();
    }, delay);

    return function () {
      clearTimeout(handler);
    };
  }, [delay].concat(_toConsumableArray(deps)));
}

exports.default = useDebouncedEffect;